import axios from 'axios';
import { AUTH_URL } from '../../../vars';

/**
 * @namespace Auth
 * @description Авторизация (Page:/login)
 */
export default {
  state: {
    user: null,
    token: null,
    avatar: null,
    is_logged: false,
  },

  mutations: {
    UPDATE_USER(state, data) {
      state.user = data;
    },
    UPDATE_AVATAR(state, data) {
      state.avatar = data.profiles[0].individual.photo;
    },
    UPDATE_TOKEN(state, token) {
      state.token = token;
    },
    UPDATE_ISLOGGEG(state, is_logged) {
      state.is_logged = is_logged;
    },

  },

  actions: {
    /**
     * @property {Object} ctx Объект vuex
     * @property {Object} payload Содержит email и пароль
     * @return {Object} Объект с ошибкой или данными пользователя
     *
     * @memberof Auth
     */
    async AUTH(ctx, payload) {
      try {
        const { data } = await axios.post(`${AUTH_URL}login/`, payload);

        ctx.commit('UPDATE_TOKEN', data.token);
        ctx.commit('UPDATE_ISLOGGEG', true); 
        localStorage.setItem('isLoggedIn', data.user);
        return data;
      } catch (e) {
        console.log(e);
        // messageHelper(e.detail, 'error', 6000, )
        throw e;
      }
    },
  },
  getters: {
    GETTERS_AVATAR(state) {
      return state.avatar;
    },
    GETTERS_CURRENT_USER(state) {
      return state.user;
    },
    GETTERS_TOKEN(state) {
      return state.token;
    },
    GETTERS_ISLOGGED(state) {
      return state.is_logged;
    },

  },
};
